import { call, put, takeLatest } from 'redux-saga/effects';
import { MARKET_SHARE_DATA_REQUEST, FETCH_SOS_CLAIM_EVENT_DATA_REQUEST } from '../actions/actionTypes';
import { fetchSoSDataSuccess, fetchSoSDataError, marketShareDataSuccess, marketShareDataFail, setMarketShareData, isLoading } from '../actions/SiteOfServiceAction';
import { getMarketSharedData, getSosData } from '@src/apps/SiteOfService/Main/Main.service';
export function* fetchSoSData(action: any) {
  try {
   
    const response = yield call(getSosData, action?.payload);
    yield put(isLoading(true));
    if (response) {
      yield put(fetchSoSDataSuccess(response?.Data));
      yield put(isLoading(false));
    }

  } catch (error) {
    yield put(fetchSoSDataError(error));
    yield put(isLoading(false));
  }

}
export function* fetchSoSMarketData(action: any) {
  try {
    const response = yield call(getMarketSharedData, action?.payload);
    if (response) {
      yield put(marketShareDataSuccess(true));
      yield put(setMarketShareData(response?.Data));
    }

  } catch (error) {
    yield put(marketShareDataFail(error));
  }

}
export function* siteOfServiceSaga() {
  yield takeLatest(FETCH_SOS_CLAIM_EVENT_DATA_REQUEST, fetchSoSData);
  yield takeLatest(MARKET_SHARE_DATA_REQUEST, fetchSoSMarketData);

  
}

export default [siteOfServiceSaga] 